module.exports = __webpack_public_path__ + "static/media/40.e4152c34.mp3";